<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="640px">
             <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details">Add Course Rating</v-flex>
                    <v-flex v-else>Update Course Rating</v-flex>
                    <v-btn icon @click="CloseCourseModal"> 
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text v-if="!Update_Details">
                    <v-flex>
                        <v-select item-value='_id' item-text='name' return-object v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course Title">
                            <template slot='selection' slot-scope='{ item }'>
                                {{ item.Course_Title }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.Course_Title }}    
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex>
                        <v-layout row>
                            <v-flex xs2 style="font-size:16px;font-weight:bold;padding:24px;">5 Star : </v-flex>
                            <v-text-field v-model="Star_5" type='number' min="0" label="No Of Users"></v-text-field>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs2 style="font-size:16px;font-weight:bold;padding:24px;">4 Star : </v-flex>
                            <v-text-field v-model="Star_4" type='number' min="0" label="No Of Users"></v-text-field>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs2 style="font-size:16px;font-weight:bold;padding:24px;">3 Star : </v-flex>
                            <v-text-field v-model="Star_3" type='number' min="0" label="No Of Users"></v-text-field>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs2 style="font-size:16px;font-weight:bold;padding:24px;">2 Star : </v-flex>
                            <v-text-field v-model="Star_2" type='number' min="0" label="No Of Users"></v-text-field>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs2 style="font-size:16px;font-weight:bold;padding:24px;">1 Star : </v-flex>
                            <v-text-field v-model="Star_1" type='number' min="0" label="No Of Users"></v-text-field>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat v-if="!Update_Details" @click="CourseReviewMap">Add Course Rating</v-btn>
                    <v-btn color="primary" flat v-else>Update Course Rating</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>
<script>
export default {
    props: ['dialog'],
    data(){
        return {

            Update_Details         : false,
            SelectedCourseDetail   : {},
            Star_5 : 0,
            Star_4 : 0,
            Star_3 : 0,
            Star_2 : 0,
            Star_1 : 0,
            Review_Array : []
        }
    },
    computed:{  
        GetCourseDetailList(){

            return this.$store.getters.GetCourseDetailsList
        },
    },
    methods:{
        CloseCourseModal(){
            this.Update_Details         = false
            this.SelectedCourseDetail   = {}
            this.Star_5 = 0
            this.Star_4 = 0
            this.Star_3 = 0
            this.Star_2 = 0
            this.Star_1 = 0
            this.Review_Array = []
            this.$emit('close')
        },
        CourseReviewMap(){

            let Review_Map = [  this.Star_1 , this.Star_2, this.Star_3, this.Star_4, this.Star_5 ]
            let Promise_Array = []
            Review_Map.forEach((element,index) => { Promise_Array.push(this.ReviewGenerate(element,index)) })

            Promise.all(Promise_Array)
                    .then(response =>{
                        
                        this.AddCourseReview()
                    })
                    .catch(error =>{
                        
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Course Rating","Color":"red","Close": false });
                    })     
        },
        ReviewGenerate(element,index){

            return new Promise((resolve,reject) =>{

                Array.from(Array(parseInt(element))).forEach((x, i) => {
                    let Review = {  Course_Id : this.SelectedCourseDetail['_id'], Review_Message : "", 
                                    Review_Number : index + 1, Reviewer_Id : "",Review_Status : true,Review_Course_Type : "Admin",
                                    Review_From : "Admin",
                                }
                        this.Review_Array.push(Review)
                });
                resolve(true)
            })

        },
        AddCourseReview(){

            if(this.Review_Array.length > 0){
                
                this.$eventHub.$emit("LOADING",'true')
                this.$http.post(`${this.$store.getters.GetProductionUrl}/coursereview/adminaddcoursereview`,this.Review_Array)
                            .then(response =>{
                                
                                let data = response["data"]["response"]
                                let Arr_Data = data && data.length > 0 ? data.map((x) => { return {...x, ...this.GetCourseDetailList.find(y => x['Course_Id'] == y['_id'])} }) : []
                                this.$store.commit('SetIndividualReview',Arr_Data)
                                this.$eventHub.$emit("LOADING",'false')
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Course Rating","Color":"green","Close": false });
                                this.CloseCourseModal()
                            })
                            .catch(err =>{

                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Course Rating","Color":"red","Close": false });
                            })

            }else{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Fill All The Details","Color":"red","Close": false });
            }
        }
    },
    mounted(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                .then(response => {
                    
                    this.$store.commit("SetCourseDetailList", response["data"]["response"]);
                    this.$eventHub.$emit("LOADING",'false')
                })
                .catch(err => {
                    this.$eventHub.$emit("LOADING",'false')
                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error while Fetching Data", Color: "red", Close: false });
                });
    }
}
</script>
<style scoped>

</style>
